import { __awaiter } from '../node_modules/tslib/tslib.es6.js';
import { getWebsiteUrl } from '../utils/domainUtil.js';

var AuthEndpoint;
(function (AuthEndpoint) {
    AuthEndpoint["SIGN_IN"] = "signIn";
    AuthEndpoint["SIGN_OUT"] = "signOut";
    AuthEndpoint["REFRESH_TOKEN"] = "refreshToken";
})(AuthEndpoint || (AuthEndpoint = {}));
const addParamAndEndpointToBuildFullAuthURL = (endpoint) => __awaiter(void 0, void 0, void 0, function* () {
    const applicationURL = yield getWebsiteUrl();
    const urlWithPath = new URL(`${applicationURL}/${endpoint}`);
    urlWithPath.searchParams.append("redirect_uri", applicationURL);
    return urlWithPath.toString();
});
const getSignInURL = () => __awaiter(void 0, void 0, void 0, function* () {
    return yield addParamAndEndpointToBuildFullAuthURL(AuthEndpoint.SIGN_IN);
});
const signOut = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const signOutURL = yield addParamAndEndpointToBuildFullAuthURL(AuthEndpoint.SIGN_OUT);
        const signOutResponse = yield fetch(signOutURL, {
            credentials: "same-origin",
        });
        return signOutResponse;
    }
    catch (err) {
        throw Error("Error refreshing token");
    }
});
const refreshToken = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const refreshTokenURL = yield addParamAndEndpointToBuildFullAuthURL(AuthEndpoint.REFRESH_TOKEN);
        const refreshTokenResponse = yield fetch(refreshTokenURL, { method: "POST" });
        return refreshTokenResponse;
    }
    catch (err) {
        throw Error("Error refreshing token");
    }
});

export { AuthEndpoint, addParamAndEndpointToBuildFullAuthURL, getSignInURL, refreshToken, signOut };
